import React, { useEffect, useRef, useState } from "react";
import "./Left_Tabs.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Dropdown } from "react-bootstrap";
import Logout_Modal from "../../common-components/common_modal/logout_modal/Logout_Modal";

const Left_Tabs = (props) => {
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const navigate = useNavigate("");
  const [activeTab, setActiveTab] = useState(0);
  // const [selectedTab, setSelectedTab] = useState("PERSONAL INFORMATION");

  const { selectedTab, setSelectedTab } = props;

  //   const [activeSubTab, setActiveSubTab] = useState(null);
  //   const [expandedTabIndex, setExpandedTabIndex] = useState(null);

  const mobile_tabs = [
    {
      tab_label: "PERSONAL INFORMATION",
    },
    {
      tab_label: "My Orders",
    },
    {
      tab_label: "Delivered Order",
    },
    {
      tab_label: "Return Order",
    },
    {
      tab_label: "Cancelled Order",
    },
    {
      tab_label: "My Wallet",
    },
    {
      tab_label: "MANAGE ADDRESS",
    },
    {
      tab_label: "CHANGE PASSWORD",
    },
    {
      tab_label: "LOGOUT",
    },
  ];

  const tabs = [
    {
      tab_label: "PERSONAL INFORMATION",
    },
    {
      tab_label: "My Orders",
    },
    {
      tab_label: "Delivered Order",
    },
    {
      tab_label: "Return Order",
    },

    {
      tab_label: "Cancelled Order",
    },
    {
      tab_label: "My Wallet",
    },
    // {
    //   subTabs: [
    //     "My Order",
    //     "Delivered Order",
    //     "Return Order",
    //     "Cancelled Order",
    //   ],
    // },
    {
      tab_label: "MANAGE ADDRESS",
    },
    {
      tab_label: "CHANGE PASSWORD",
    },
    {
      tab_label: "LOGOUT",
    },
  ];

  //   useEffect(() => {
  //     const creditsTab = tabs.find((tab) => tab.tab_label === "MY ORDERS");
  //     const index = tabs.findIndex((tab) => tab.tab_label === "MY ORDERS");

  //     if (activeTab === index && creditsTab?.subTabs?.length > 0) {
  //       if (!activeSubTab || !creditsTab.subTabs.includes(activeSubTab)) {
  //         const defaultSubTab = creditsTab.subTabs[0];
  //         setActiveSubTab(defaultSubTab);
  //         props?.setSelectedTab(defaultSubTab);
  //       }
  //     }
  //   }, [activeTab]);

  //   const toggleExpand = (index) => {
  //     setExpandedTabIndex((prev) => (prev === index ? null : index));
  //   };

  useEffect(() => {
    const index = tabs.findIndex((tab) => tab.tab_label === selectedTab);

    if (index !== -1) {
      setActiveTab(index);
    }
  }, [selectedTab]);

  return (
    <section className="Left_Tabs">
      <div className="desktop_sidebar">
        {tabs.map((value, index) => (
          <React.Fragment key={index}>
            {/* Main Tab */}
            <div
              className={`tabs_main_div ${
                activeTab === index || value.subTabs?.includes(selectedTab)
                  ? "active red_bg_div"
                  : "blue_bg_div"
              }`}
              // onClick={() => {
              //   if (value.tab_label === "LOGOUT") {
              //     setshowLogoutModal(true);
              //     return;
              //   }

              //   setActiveTab(index);

              //   if (!value.subTabs) {
              //     setSelectedTab(value.tab_label);
              //     props.setSelectedTab(value.tab_label);
              //   }
              // }}

              onClick={() => {
                if (value.tab_label === "LOGOUT") {
                  setshowLogoutModal(true);
                  return;
                }

                setActiveTab(index);
                setSelectedTab(value.tab_label);
              }}
            >
              <div className="text_holder">
                <p className="tab_name">{value.tab_label}</p>
              </div>
            </div>

            {/* Always Visible Subtabs */}
            {value.subTabs && (
              <div className="inner_tabs">
                {value.subTabs.map((subTab, subIndex) => (
                  <div
                    key={subIndex}
                    className={`inner_tab ${
                      selectedTab === subTab ? "active-sub-tab" : ""
                    }`}
                    onClick={() => {
                      setActiveTab(index);
                      setSelectedTab(subTab);
                      props.setSelectedTab(subTab);
                    }}
                  >
                    {subTab}
                  </div>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="mobile_div">
        {mobile_tabs.map((value, index) => {
          const isMainActive = activeTab === index;

          return (
            <div
              key={index}
              className={`tabs_main_div ${
                isMainActive ? "active red_bg_div" : "blue_bg_div"
              }`}
              // onClick={() => {
              //   if (value.tab_label === "LOGOUT") {
              //     setshowLogoutModal(true);
              //     return;
              //   }

              //   setActiveTab(index);
              //   setSelectedTab(value.tab_label);
              //   props.setSelectedTab(value.tab_label);
              // }}
              onClick={() => {
                if (value.tab_label === "LOGOUT") {
                  setshowLogoutModal(true);
                  return;
                }

                setActiveTab(index);
                setSelectedTab(value.tab_label);
              }}
            >
              <div className="text_holder">
                <p className="tab_name">{value.tab_label}</p>
              </div>
            </div>
          );
        })}
      </div>

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setshowLogoutModal(false)}
      />
    </section>
  );
};

export default Left_Tabs;
